// src/components/ServiceProfile/ProfileData.jsx
import React, { useState, useEffect } from 'react';
import './ProfileData.css';
import { apiRequest } from '../../utils';
import { resizeImage } from '../../ResizeImage';
import translations from '../../lang';

const Profile = () => {
  const language = localStorage.getItem('language') || 'ro';
  const t = translations[language];

  const [profileData, setProfileData] = useState({
    profile_picture_url: null,
    user_data: {
      first_name: '',
      last_name: '',
      email: '',
      phone_number: '',
      username: '',
      profile_picture2: null,
    },
  });

  // Profil betöltése
  useEffect(() => {
    apiRequest(`${process.env.REACT_APP_API}/api/user-profile/`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    })
      .then((response) => response.json())
      .then((data) => {
        setProfileData((prev) => ({
          ...prev,
          profile_picture_url:
            data.profile_picture_url || '/media/profile_pictures/default.jpg_MynwFn5.jpg',
          user_data: { ...prev.user_data, ...data.user_data },
        }));
      })
      .catch((error) => console.error('Profile fetch error:', error));
  }, []);

  const handleImageUpload = async (event) => {
    const file = event.target.files[0];
    if (!file) return;
    try {
      const resizedBlob = await resizeImage(file, 200, 'profile');
      const formData = new FormData();
      formData.append('profile_picture', resizedBlob, file.name);

      apiRequest(`${process.env.REACT_APP_API}/api/upload-profile-picture/`, {
        method: 'POST',
        body: formData,
        headers: {
          Authorization: `Bearer ${localStorage.getItem('access_token')}`,
          'Accept-Language': language,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.success) {
            setProfileData((prev) => ({
              ...prev,
              profile_picture_url: `data:image/jpeg;base64,${data.file_data}`,
            }));
            window.location.href = '/serviceprofile/profiledata';
          } else {
            alert(t.profile_picture_upload_error);
          }
        })
        .catch((error) => console.error('Error uploading profile picture:', error));
    } catch (error) {
      console.error('Image resize error:', error);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setProfileData((prev) => ({
      ...prev,
      user_data: {
        ...prev.user_data,
        [name]: value,
      },
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    apiRequest(`${process.env.REACT_APP_API}/api/user-profile/update/`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(profileData.user_data),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.error) alert(t.profile_update_error);
        else alert(t.profile_update_success);
      })
      .catch((error) => console.error('Error updating profile:', error));
  };

  // Fiók törlése → logout + redirect Home
  const handleDeleteAccount = async () => {
    const ok = window.confirm(t.confirm_delete_account);
    if (!ok) return;

    try {
      const res = await apiRequest(`${process.env.REACT_APP_API}/api/delete-account/`, {
        method: 'DELETE',
        headers: {
          Authorization: `Bearer ${localStorage.getItem('access_token')}`,
          'Accept-Language': language,
        },
      });

      let data = {};
      try { data = await res.json(); } catch (_) {}

      if (res.ok && (data?.success ?? true)) {
        alert(t.account_deleted_success);

        // ⬇️ teljes kijelentkeztetés és helyi állapot takarítás
        try {
          localStorage.removeItem('access_token');
          localStorage.removeItem('refresh_token');
          localStorage.removeItem('user_id');
          localStorage.removeItem('username');
          localStorage.removeItem('user_type');
          localStorage.setItem('isLoggedIn', 'false');
        } catch {}

        // ⬇️ nyitóoldalra vissza
        window.location.replace('/Home'); // ha nálad a kezdőoldal "/", cseréld erre
      } else {
        alert(data?.error || t.account_deleted_error);
      }
    } catch (err) {
      console.error('Delete account error:', err);
      alert(t.account_deleted_error);
    }
  };

  const fullName = `${profileData.user_data.first_name || ''} ${profileData.user_data.last_name || ''}`.trim();

  return (
    <div className="profile-page">
      <div className="profile-container1">
        <h1>{t.profile_data}</h1>

        {/* Bal kártya */}
        <div className="profile-left-card">
          <div
            className="empty-card"
            style={{
              backgroundImage: profileData.user_data.profile_picture2
                ? `url(data:image/jpeg;base64,${profileData.user_data.profile_picture2})`
                : `url(${process.env.REACT_APP_API}/media/profile_pictures/default.jpg)`,
            }}
          />
          <label className="custom-file-upload1" title={t.upload_picture}>
            {t.upload_picture}
            <input type="file" accept="image/*" onChange={handleImageUpload} />
          </label>

          <div className="profile-meta">
            <h3>{fullName || t.username}</h3>
            <p><strong>{t.username}:</strong> {profileData.user_data.username}</p>
          </div>

          <div className="delete-block">
            <button
              type="button"
              className="btn btn-danger danger-delete-account-btn"
              onClick={handleDeleteAccount}
              title={t.delete_account}
            >
              {t.delete_account}
            </button>
          </div>
        </div>

        {/* Jobb kártya – űrlap */}
        <div className="profile-form-card">
          <h2>{t.update_data}</h2>
          <div className="profile-details1">
            <form onSubmit={handleSubmit}>
              <div>
                <label>{t.first_name}:</label>
                <input
                  type="text"
                  name="first_name"
                  value={profileData.user_data.first_name}
                  onChange={handleChange}
                />
              </div>

              <div>
                <label>{t.last_name}:</label>
                <input
                  type="text"
                  name="last_name"
                  value={profileData.user_data.last_name}
                  onChange={handleChange}
                />
              </div>

              <div>
                <label>{t.email}:</label>
                <input
                  type="email"
                  name="email"
                  value={profileData.user_data.email}
                  onChange={handleChange}
                />
              </div>

              <div>
                <label>{t.phone_number}:</label>
                <input
                  type="text"
                  name="phone_number"
                  value={profileData.user_data.phone_number}
                  onChange={handleChange}
                />
              </div>

              <div className="form-actions">
                <button type="submit" className="btn btn-primary">
                  {t.update_data}
                </button>
              </div>
            </form>
          </div>
        </div>

      </div>
    </div>
  );
};

export default Profile;
